import { useInfiniteQuery } from '@tanstack/react-query';
import { getForecastInspectLiquidated } from 'Services/forecasts';
import { trackError } from 'Utils/errorMonitoring';
import { RESULTS_PER_PAGE } from 'Utils/constants';

export default function useInfiniteForecastInspectLiquidated(id, filters) {
    return useInfiniteQuery(
        ['forecasts', id, 'inspect', 'liquidated', filters],
        async ({ pageParam = 1 }) => {
            const response = await getForecastInspectLiquidated(id, {
                ...filters,
                page: pageParam,
            });
            return response;
        },
        {
            refetchOnWindowFocus: false,
            onError: (err) => trackError(err),
            getNextPageParam: (lastPage, allPages) => {
                const pagesLoaded = allPages.length;
                const totalPages = Math.ceil(lastPage.count / RESULTS_PER_PAGE);
                return pagesLoaded < totalPages ? pagesLoaded + 1 : false;
            },
        },
    );
}
